<div class="main-ncs-header-div">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="logo-div" (click)="goHome()" style="cursor: pointer;">
      <img src="../../../assets/logo/ias-small-logo.png" alt="ias-logo" draggable="false">
      <h1>Indian Administrative Service <br>Central Association</h1>
    </div>
    <div class="navigationmenu d-flex align-items-center">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <!-- Toggler (shows only below lg) -->
          <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar">
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Normal Navbar (visible on lg and up) -->
          <div class="collapse navbar-collapse d-none d-lg-flex" id="navbarNavAltMarkup">
            <div class="navbar-nav ms-auto">
              <!-- <a class="nav-link" [routerLink]="'/about-us'" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">About us</a> -->

              <a class="nav-link" [routerLink]="'membership'" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">Membership</a>

              <a class="nav-link" [routerLink]="'community'" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">Community</a>

              <li class="nav-item dropdown">
                <a class="d-flex align-items-center text-decoration-none nav-link" data-bs-toggle="dropdown"
                  aria-expanded="false" id="dropdownMenuButton">
                  <span class="me-2">Resources</span>
                  <i class="arrow-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none">
                      <path d="M12.6 0.8L14 2.2 7 9.2 0 2.2 1.4 0.8 7 6.375 12.6 0.8Z" fill="#222" />
                    </svg>
                  </i>
                </a>
                <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
                  <li><a class="dropdown-item" [routerLink]="'news-blogs'">News & Blogs</a></li>
                  <li><a class="dropdown-item" [routerLink]="'good-governance-initiatives'">Good Governance Initiatives</a></li>
                </ul>
              </li>

              <a class="nav-link" [routerLink]="'contact-us'" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">Contact us</a>
            </div>
          </div>

          <!-- Offcanvas (only visible on mobile/tablet) -->
          <div class="offcanvas offcanvas-start d-lg-none" tabindex="-1" id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasNavbarLabel">Menu</h5>
              <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
              <div class="navbar-nav">
                <!-- <a class="nav-link" [routerLink]="'/about-us'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">About us</a> -->

                <a class="nav-link" [routerLink]="'membership'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">Membership</a>

                <a class="nav-link" [routerLink]="'community'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">Community</a>

                <a class="nav-link" [routerLink]="'news-blogs'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">News</a>

                <a class="nav-link" [routerLink]="'good-governance-initiatives'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">Good Governance Initiatives</a>

                <a class="nav-link" [routerLink]="'contact-us'" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">Contact us</a>

              </div>
            </div>
          </div>
        </div>
      </nav>

      <ng-container *ngIf="isLoggedIn && isLoggedIn !== null">

        <!-- <ng-container *ngIf="userRole === 'admin'; else userMenu">

          <button class="btn btn-prime" [routerLink]="'/home'">Admin Dashboard</button>
          <li><a class="dropdown-item" [routerLink]="'/home/profile'">Admin Profile</a></li>
          <li><a class="dropdown-item" [routerLink]="'/home'">Admin Dashboard</a></li>
        </ng-container>


        <ng-template #userMenu>
                    <button class="btn btn-prime" [routerLink]="'/user-home'">Member Dashboard</button>

          <li><a class="dropdown-item" [routerLink]="'/user-home/user-profile'">User Profile</a></li>
          <li><a class="dropdown-item" [routerLink]="'/user-home'">User Dashboard</a></li>
        </ng-template> -->

        <div class="dropdown" *ngIf="isLoggedIn">
          <button class="btn dropdown-toggle user-profile d-flex align-items-center p-0" type="button"
            id="profileDropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="avatar">
              <ng-container
                *ngIf="userRole === 'admin' || userRole === 'state_association_admin' ? user?.profilePic : user?.doptOfficer?.profilePic; else initials">
                <img [src]="userRole === 'admin' || userRole === 'state_association_admin' ? user?.profilePic : user?.doptOfficer?.profilePic"
                  alt="User Avatar" />
              </ng-container>
              <ng-template #initials>
                {{ getUserInitials() }}
              </ng-template>
            </div>

          </button>


          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">

            <!-- 🔹 Admin Menu -->
            <ng-container *ngIf="userRole === 'admin'">
              <li><a class="dropdown-item" [routerLink]="'/home/profile'">Admin Profile</a></li>
              <li><a class="dropdown-item" [routerLink]="'/home'">Admin Dashboard</a></li>
            </ng-container>

            <!-- 🔸 State Association Admin Menu -->
            <ng-container *ngIf="userRole === 'state_association_admin'">
              <li><a class="dropdown-item" [routerLink]="'/state-dashboard'">State Admin Dashboard</a></li>
            </ng-container>

            <!-- 🔹 Regular User Menu -->
            <ng-container *ngIf="userRole === 'user'">
              <li><a class="dropdown-item" [routerLink]="'/user-home/user-profile'">User Profile</a></li>
              <li><a class="dropdown-item" [routerLink]="'/user-home'">User Dashboard</a></li>
            </ng-container>

            <li>
              <hr class="dropdown-divider" />
            </li>

            <li>
              <a class="dropdown-item text-danger" (click)="logout()" style="cursor: pointer;">Logout</a>
            </li>
          </ul>

        </div>
      </ng-container>
      <ng-container *ngIf="!isLoggedIn && isLoggedIn !== null"><button class="btn btn-prime" [routerLink]="''">Log
          in / Sign up</button></ng-container>
    </div>
  </div>
</div>